/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;
const SvgRadiobuttonOn = (props: Props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm0 1.33a6.67 6.67 0 1 0 0 13.34A6.67 6.67 0 0 0 8 1.33ZM8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRadiobuttonOn as RadiobuttonOn };
